import React from 'react';
import './CheckMarkBox.css';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import type { AppState } from '@store/store';
import { useSelector } from 'react-redux';

interface CheckMarkBoxProps {
    text?: string;
}

function CheckMarkBox(props: CheckMarkBoxProps) {
    const lang = useSelector((state: AppState) => state.employee.language);
    const checkText = getLanguageTexts(lang).skills.oftenUsed.success;

    const text = props.text ? props.text : checkText;

    return (
        <div className="checkMarkBox">
            <svg className="checkmark" viewBox="0 0 52 52">
                <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                <path className="checkmark__check" fill="none" d="M14 27l7 7 16-16" />
            </svg>
            <span className="checkText">{text}</span>
        </div>
    );
}

export default CheckMarkBox;
